import React from "react";
import { classNames } from "@root/_utils";

type CheckboxProps = {
  label: string;
  name: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  checked: boolean;
  value?: string;
  error?: {
    error: boolean;
    message: string;
  };
};

const CheckBox = ({
  label,
  name,
  onChange,
  checked,
  value,
  error,
}: CheckboxProps): React.JSX.Element => {

  const hasError = error && error.error === true;

  const checkboxClassNames = classNames(
    "gc__checkbox_input",
    { "gc__input_field_error": hasError },
  );

  const errorMarkup = (hasError) ? (
    <p className="gc__input_field_error_message">
      {error.message}
    </p>
  ) : null;

  return (
    <div className="gc__checkbox_wrapper">
      <label className="gc__checkbox_container">
        <input
          className={checkboxClassNames}
          type="checkbox"
          id=""
          name={name}
          value={value || ""}
          onChange={onChange}
          checked={checked}
        />
        <span className="gc__checkbox_checkmark" />
        {label}
      </label>
      {errorMarkup}
    </div>
  );
};

export default CheckBox;
